import { ApolloClient, InMemoryCache, gql } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react/context";

const WORDPRESSURL = process.env.REACT_APP_WORDPRESS_URL;

export const wordpressClient = new ApolloClient({
  uri: WORDPRESSURL,
  cache: new InMemoryCache(),
});

export const nodeDataClient = (uri) => {
  new ApolloClient({
    uri: `${WORDPRESSURL}/${uri}`,
    cache: new InMemoryCache(),
  });
};
